import { Data } from '@wix/component-protocol/schema';
import { Link } from '@wix/document-services-types';
import type {
  ElementLink,
  ElementData,
} from '@wix/public-editor-platform-interfaces';

import { PlatformPrivateServices } from '../../../PlatformPrivateServices';
import {
  SelectLinkSharedOptions,
  SelectLinkOptions,
} from '@wix/editor-platform-sdk-types';

export type ISelectLinkParams =
  | {
      dataItemKey: string;
      options?: SelectLinkSharedOptions;
    }
  | {
      value?: ElementLink;
      options?: SelectLinkOptions & {
        onChange?: (value: ElementLink) => void;
      };
    };

export class HostLinkSelectorAPI {
  constructor(private ps: PlatformPrivateServices) {}

  /**
   * Returns the internal Link type from hostAPI.
   * The conversion to ElementLink happens via getData() flow,
   * which adds displayName through PublicDataAdapter.toPublicLink().
   */
  async selectLink(
    dataItemKey: string,
    context: {
      dataDefinitions: Data;
      data: ElementData;
    },
    options?: SelectLinkSharedOptions,
  ): Promise<Link | null | undefined> {
    const currentLink = context.data[dataItemKey] as ElementLink | undefined;
    const { linkTypes, appIds, hideInnerRoute } =
      context.dataDefinitions[dataItemKey]?.link ?? {};

    return this.ps.hostAPI.editor.selectLink(currentLink, {
      linkTypes,
      appIds,
      hideInnerRoute: hideInnerRoute ?? undefined,
      ...options,
    });
  }
}
